import type { NormalizedUnreadMessage } from '../../types/unreadMessages'
import { isFrenchLanguage } from '../../utils/chatUiLocale'

export type UnreadMessageCardProps = {
  message: NormalizedUnreadMessage
  index?: number
  onOpen?: () => void
}

/** One unread / urgent item card, optionally clickable for thread open. */
export function UnreadMessageCard(props: UnreadMessageCardProps) {
  const { message, index, onOpen } = props
  const urgent = message.isUrgent
  const openable = Boolean(onOpen && message.threadContext.discussionId?.trim())
  const fr = isFrenchLanguage()

  return (
    <button
      type="button"
      className={
        urgent
          ? `vnw-unreadCard ${openable ? '' : 'vnw-unreadCard--static '}vnw-unreadCard--urgent`
          : `vnw-unreadCard ${openable ? '' : 'vnw-unreadCard--static '}vnw-unreadCard--default`
      }
      disabled={!openable}
      onClick={onOpen}
      aria-label={
        fr
          ? `Message de ${message.sender}${urgent ? ', urgent' : ''}`
          : `Message from ${message.sender}${urgent ? ', urgent' : ''}`
      }
    >
      <div className="vnw-unreadCardHeader">
        <span className="vnw-unreadCardSender">
          {typeof index === 'number' ? `${index + 1}. ${message.sender}` : message.sender}
        </span>
        <span className="vnw-unreadCardBadges">
          {message.isUnread ? (
            <span className="vnw-unreadBadge vnw-unreadBadge--unread" aria-hidden="true">
              {fr ? 'Non lu' : 'Unread'}
            </span>
          ) : null}
          {urgent ? (
            <span className="vnw-unreadBadge vnw-unreadBadge--urgent" aria-hidden="true">
              {fr ? 'Urgent' : 'Urgent'}
            </span>
          ) : null}
        </span>
      </div>
      <div className="vnw-unreadCardSubject">{message.subject}</div>
      {message.recipient.trim() ? (
        <div className="vnw-unreadCardRecipient">
          {fr ? `Pour : ${message.recipient}` : `To: ${message.recipient}`}
        </div>
      ) : null}
      {message.preview ? <div className="vnw-unreadCardPreview">{message.preview}</div> : null}
      {message.dateLabel ? (
        <div className="vnw-unreadCardMeta">
          <span className="vnw-unreadCardDate">{message.dateLabel}</span>
        </div>
      ) : null}
    </button>
  )
}
